const strings = [
  "Full Stack Web Developer",
  "Flutter Developer",
  "Android Developer",
  "Learner",
  "Problem Solver",
];
const picUrl =
  "https://avatars.githubusercontent.com/u/55583515?v=4";

export { strings, picUrl };
